module.exports = __webpack_public_path__ + "img/KH-邀请3.b45b3185.png";